import { Component } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';

// components
import { HeaderComponent } from '@shared/components/header/header.component';
import { NavbarComponent } from '@shared/components/navbar/navbar.component';
import { FooterComponent } from '@shared/components/footer/footer.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, NavbarComponent, RouterModule, FooterComponent],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class PagesLayoutComponent {
  constructor(private $router: Router) {}

  get isHomePage(): boolean {
    const url = this.$router.url.split('#')[0];
    return url === '/' || url === '';
  }

  get isAuthPage(): boolean {
    const url = this.$router.url.split('#')[0];
    return url.startsWith('/acceder');
  }
}
